import React from 'react'

const Header = () => {
  return (
    <header>
      <h1>BITCOIN DOMINO</h1>
      <p className="subtitle">Tracking the adoption of Bitcoin by nation-states across the world, one domino piece at a time.</p>
    </header>
  )
}

export default Header
